module.exports = __webpack_public_path__ + "static/media/summaryHeader.a13569c1.svg";